import type { ReactNode } from 'react'

import { authDisabled, mockSignedOut } from '@/config/env'

import { hasSession } from './identityAuth'
import { LoginScreen } from './LoginScreen'

/**
 * Requires an identity session (in-memory token or a refresh token) unless auth is disabled.
 * `VITE_MOCK_ROLE=signed-out` previews the sign-in screen in mock mode.
 */
export function SessionGate({ children }: { children: ReactNode }) {
  if ((authDisabled && !mockSignedOut) || hasSession()) return <>{children}</>
  return <LoginScreen />
}
